import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navigation } from '../../common';

class LeftNav extends Component {
  handleSettings() {
    const { dispatch, website } = this.props;
    dispatch(
      show('WebsiteFormModal', {
        website,
        heading: `Website Settings - ${website.name}`,
        formAction: 'Update',
      }),
    );
  }

  activeRoute(regex) {
    const { pathname } = this.props;
    return regex.test(pathname) ? 'active' : null;
  }

  render() {
    const { website } = this.props;
    const { slug } = website;
    const navItems = (
      <ul className="nav metismenu" id="side-menu" ref="menu">
        <li className={this.activeRoute(/dashboard/)}>
          <Link to={slug ? `/publisher/home/websites/${slug}/dashboard` : null}>
            <FontAwesomeIcon icon="tachometer-alt" /> Dashboard
          </Link>
        </li>
        {/* <li className={this.activeRoute(/pixel/)}>
          <Link to={slug ? `/publisher/home/websites/${slug}/pixel` : null}>
            <FontAwesomeIcon icon="tag" /> Pixel
          </Link>
        </li>
        <li className={this.activeRoute(/templates/)}>
          <a href="javascript:void(0);">
            <FontAwesomeIcon icon="sticky-note" /> Templates
            <span className="fa arrow" />
          </a>
          <ul className="nav nav-second-level collapse">
              <li className={this.activeRoute(/templates\/website/)}>
                <Link to={slug ? `/publisher/home/websites/${slug}/templates/website` : null}>
                  <span className="nav-label">Website</span>
                </Link>
              </li>
              <li className={this.activeRoute(/templates\/email/)}>
                <Link to={slug ? `/publisher/home/websites/${slug}/templates/email` : null}>
                  <span className="nav-label">Email</span>
                </Link>
              </li>
          </ul>
        </li> */}
        <li className={this.activeRoute(/website_settings/)}>
          <Link to={slug ? `/publisher/home/websites/${slug}/website_settings` : null}>
            <FontAwesomeIcon icon="cog" /> Website Settings
          </Link>
        </li>
        <li>
          <a href="https://www.jobadx.com/publisher/faq" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon="question-circle" /> FAQ
          </a>
        </li>
        <li className={this.activeRoute(/tos/)}>
          <Link to={slug ? `/publisher/home/websites/${slug}/tos` : null}>
            <FontAwesomeIcon icon="file-alt" /> Terms Of Service
          </Link>
        </li>
      </ul>
    );

    return <Navigation navItems={navItems} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { website, pathname } = ownProps;
  const {
    publisher: { websites },
  } = state;

  return { website, pathname, isLoading: websites.loading };
};

export default connect(mapStateToProps)(LeftNav);
